import { ConcreteEncodable } from "./ConcreteEncodable";

import { ManualPriceImplEncoder } from "../../encoder/ManualPriceImplEncoder";

import * as CubiqTS from "../../index";
import { ManualPrice } from "../ManualPrice";

export class ManualPriceImpl extends ConcreteEncodable implements ManualPrice {
  public static enType: string = "com.bcdfx.model.event.ManualPriceImpl";

  /*FID=1*/
  public requirementId: CubiqTS.Long | null = null;
  /*FID=2*/
  public bid: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public offer: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ManualPriceImplEncoder.Instance;
    this.setEncodableType(ManualPriceImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ManualPriceImpl[" +
      "requirementId=" +
      this.requirementId +
      "bid=" +
      this.bid +
      "offer=" +
      this.offer +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
